import { icon, type IconName } from './icons';
import { getView, onViewChange, setView, type ViewId } from './view';

interface TabSpec {
  view: ViewId;
  label: string;
  glyph: IconName;
}

const TABS: TabSpec[] = [
  { view: 'view-chat', label: 'Chat', glyph: 'chat' },
  { view: 'view-explorer', label: 'Files', glyph: 'files' },
  { view: 'view-optimize', label: 'Savings', glyph: 'pipeline' },
  { view: 'view-account', label: 'Account', glyph: 'account' },
];

/**
 * The bottom tab bar for the single-pane mobile layout. Hidden entirely above 900px — the desktop
 * shell shows every pane at once and navigates via the left rail instead.
 */
export class MobileTabBar {
  private buttons = new Map<ViewId, HTMLButtonElement>();

  constructor(container: HTMLElement) {
    const bar = document.createElement('nav');
    bar.id = 'mobile-tabbar';
    bar.setAttribute('aria-label', 'Sections');

    for (const tab of TABS) {
      const button = document.createElement('button');
      button.type = 'button';
      button.innerHTML = `${icon(tab.glyph)}<span class="tab-label">${tab.label}</span>`;
      button.addEventListener('click', () => setView(tab.view));
      bar.appendChild(button);
      this.buttons.set(tab.view, button);
    }

    container.appendChild(bar);
    this.sync(getView());
    onViewChange((view) => this.sync(view));
  }

  private sync(view: ViewId) {
    for (const [tabView, button] of this.buttons) {
      const on = tabView === view;
      button.classList.toggle('active', on);
      button.setAttribute('aria-current', on ? 'page' : 'false');
    }
  }
}
